import React from "react";
import {Circle, GoogleMap, InfoWindow, LoadScript, Marker, MarkerClusterer, TransitLayer} from '@react-google-maps/api';
import Constants from '../../inc/Constants';

const mapContainerStyle = {
    height: "400px",
    width: "100%"
}

const MapContainer = (props) => {
    return (
        <LoadScript googleMapsApiKey={Constants.GOOGLE_MAPS_API_KEY}>
            <GoogleMap
                center={props.mapCenter}
                zoom={13}
                onClick={props.onMapClicked}
                onLoad={(map) => {
                    if(window.walkScoreWidget !== undefined) {
                        window.walkScoreWidget.setOptions({
                            map: map,
                            origin: props.mapCenter.lat + ',' + props.mapCenter.lng,
                            show: false,
                            mode: window.walkscore.TravelTime.Mode.DRIVE
                        });
                    }

                    if(window.walkScoreWidget === undefined) {
                        window.walkScoreWidget = new window.walkscore.TravelTimeWidget({
                            map: map,
                            origin: props.mapCenter.lat + ',' + props.mapCenter.lng,
                            show: false,
                            mode: window.walkscore.TravelTime.Mode.DRIVE
                        });
                    }
                }}
                id="nearbyPlacesMap"
                mapContainerStyle={mapContainerStyle}
            >
                <TransitLayer />
                {!!props.hidden_address ?
                    <Circle
                        center={{
                            lat: parseFloat(props.mapCenter.lat),
                            lng: parseFloat(props.mapCenter.lng)
                        }}
                        visible={true}
                        radius={500}
                        options={{
                            strokeColor: "#004085",
                            fillColor: "#cce5ff",
                        }}
                    />
                    :
                    <Marker
                        key={1}
                        visible={true}
                        icon={
                            (props.theme === 'era'
                                ?
                                {
                                    url: '/images/mapsicon_era.svg',
                                    scaledSize: {width: 70, height: 75}
                                }
                                :
                                {
                                    url: '/images/mapsicon.png',
                                    scaledSize: {width: 28, height: 45}
                                }
                            )
                        }
                        position={props.mainAddress}
                    />
                }
                <MarkerClusterer
                    averageCenter={false}
                    enableRetinaIcons={true}
                    gridSize={20}
                    maxZoom={15}
                    ignoreHidden={true}
                    minimumClusterSize={15}
                >
                    {(clusterer) => {
                        return props.nearbyPlaces.length > 0 && props.nearbyPlaces.map((place, index) => <Marker
                                key={place.id}
                                position={{
                                    lat: place.location.latitude,
                                    lng: place.location.longitude,
                                }}
                                onClick={() => props.onMarkerClick(this, place.id)}
                                clusterer={clusterer}
                            >
                                    {props.selectedPlace === place.id && <InfoWindow
                                        onCloseClick={props.onInfoWindowClose}
                                    >
                                        <div>{place.displayName.text}</div>
                                    </InfoWindow>}
                                </Marker>
                            )
                        }
                    }
                </MarkerClusterer>
            </GoogleMap>
        </LoadScript>
    );
};

export default MapContainer;
